import { render, staticRenderFns } from "./PrivacyPolicyBanner.vue?vue&type=template&id=7b976892"
import script from "./PrivacyPolicyBanner.vue?vue&type=script&lang=js"
export * from "./PrivacyPolicyBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports